<template>
  <div>
    <div class="container-fluid container-froDesk">
      <div class="wrapper">
        <div class="content-page content-froDesk">
          <div class="content">
            <div class="row">
              <!-- 科研成果 -->
              <div class="col-lg-12">
                <div class="card">
                  <div class="card-body">
                    <div class="dropdown float-right">
                      <ol class="breadcrumb m-0 p-0">
                        <li class="breadcrumb-item"><a href="javascript: void(0);">首页</a></li>
                        <li class="breadcrumb-item"><a href="javascript: void(0);">科研成果</a></li>
                        <li class="breadcrumb-item active">{{columnTitleCN}}</li>
                      </ol>
                    </div>
                    <h3 class="header-title froDeskHeader-tit mb-3 pb-2">
                      <span class="tit">{{columnTitleCN}}</span>
                      <span class="ml-1">{{columnTitleEN}}</span>
                    </h3>
                    <div class="General-lists">
                      <ul class="froDesk-Lists mb-3">
                        <li class="li_3" v-for="(item,index) in researchPaperList" :key="index" @click="goArticleDetail(item.id)">
                          <i class="mdi mdi-arrow-right"></i>
                          <a href="javascript: void(0);">{{item.title}}</a>
                          <span class="name">{{item.author}}</span>
                          <span class="time">{{item.createTime | getTime}}</span>
                        </li>
                      </ul>
                      <el-pagination :page-size="params.pageSize" layout="prev, pager, next" :total="total" @current-change="handlePageChange"></el-pagination>
                    </div>
                  </div>
                </div>
              </div>
              <!-- end 科研成果-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
	import { getColumnList } from '@/api/before/home.js'
export default {
  name: "papersList",
  data() {
    return {
			columnTitleCN:'科研论文',
			columnTitleEN:'Paper Of Research',
			params:{//科研论文参数
				"id": 18,
				"pageNumber": 1,
				"pageSize": 10,
			},
      researchPaperList:[],//科研论文
      total: 0,
    };
  },
  created() {
		let columnId = this.$route.query.columnId
		if (columnId) {
			if (columnId == 18) {
				this.columnTitleCN = '科研论文'
				this.columnTitleEN = 'Paper Of Research'
			}else if (columnId == 19) {
				this.columnTitleCN = '获奖成果'
				this.columnTitleEN = 'Awarded Results'
			}
			this.params.id = columnId
			this.getResearchPaperList()
		}
	},
  methods: {
		// 跳转到文章详情
		goArticleDetail(id){
			this.$router.push('/publicDetails/'+id)
		},
		// 获取科研论文文章
		async getResearchPaperList(){
			const res = await getColumnList(this.params)
			if (res.code == 200) {
				this.researchPaperList = res.data.records
				this.total = res.data.total
			}else{
				this.$message.error(res.data)
			}
		},
    // 分页器
    handlePageChange(val) {
      this.params.pageNumber = val;
      this.getResearchPaperList();
    },
  },
};
</script>

<style>
/* 分页器样式 */
.el-pagination {
  text-align: right;
}
.el-pager li {
  margin: 0 4px;
  padding: 0;
  font-size: 13px;
  min-width: 28px;
  height: 28px;
  line-height: 28px;
  box-sizing: border-box;
}
.el-pager li.active {
  color: #fff;
  background-color: #727cf5;
  border-color: #727cf5;
  border-radius: 50%;
}
.el-pager li.active:hover {
  color: #fff;
  background-color: #727cf5;
  border-color: #727cf5;
}
.el-pager li:hover {
  color: #313a46;
  text-decoration: none;
  background-color: #e9ecef;
  border-color: #dee2e6;
  border-radius: 50%;
}
</style>